import { atom } from "jotai";

const defaultRoute = window.location.pathname || "/";

export const ActiveRouteAtom = atom<string>(defaultRoute);
